module.exports = __webpack_public_path__ + "img/70.7.Chla.97f6ca04.png";